var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Card',[_c('div',{staticClass:"MapBox"},[_c('div',{attrs:{"id":"allmap"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }